import { CONTENT } from "@/content";
import { Link } from "react-router-dom";
import { BorderBeam } from "./border-beam";

type Props = {
  onCTA: () => void;
  onHome: () => void;
};

export function Footer({ onCTA, onHome }: Props) {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-top">
          <div>
            <button className="footer-brand" onClick={onHome} type="button">
              UdiSchool
            </button>
            <p className="footer-tag">{CONTENT.brand.tagline}</p>
          </div>
          <div className="footer-cta">
            <button className="btn btn-gold btn-lg btn-beam btn-beam-gold" onClick={onCTA}>
              <BorderBeam />
              Avaliação Diagnóstica gratuita <span className="arr">→</span>
            </button>
            <span className="footer-note">WhatsApp · {CONTENT.brand.whatsapp}</span>
          </div>
        </div>
        <hr className="footer-rule" />
        <div className="footer-bottom">
          <span>© {year} UdiSchool · Uberlândia, MG</span>
          <span className="footer-links">
            <Link to="/privacidade">Política de Privacidade</Link>
            <span>
              Site desenvolvido por{" "}
              <a href="https://www.vitorcg.com.br" target="_blank" rel="noopener">
                Vitor Gomes
              </a>
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
}
